<template>
  <div class="d-flex justify-content-start align-items-end mb-2">
      <b-form-group label="Name" class="mr-2">
        <b-form-input size="sm" v-model="filters.name" @input="handleSearch" />
      </b-form-group>
      <!-- <b-form-group label="Type" class="mr-2">
        <b-form-select v-model="filters.accountTypeId" @change="handleSearch">
          <option :value="null">All</option>
          <option
            v-for="(type) in sortSelect(sortedAccountTypes)"
            :key="type.id"
            :value="type.id"
          >{{type.name}}</option>
        </b-form-select>
      </b-form-group> -->
      <b-form-group label="Attributes" class="mr-2">
        <b-form-select v-model="filters.attributeId" @change="handleSearch">
          <option :value="null">All</option>
          <option
            v-for="(type) in sortSelect(filteredAttributes,'attributeName')"
            :key="type.id"
            :value="type.id"
          >{{type.attributeName}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Country" class="mr-2" style="width: 150px !important;">
        <b-form-select v-model="filters.countryCode" @change="handleSearch">
          <option :value="null">All</option>
          <option v-for="(countryCode) in sortSelect(countryCodes,'country')" v-bind:key="countryCode.code2"
                  v-bind:value="countryCode.country">{{countryCode.country}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="State" class="mr-2">
        <b-form-input size="sm" v-model="filters.state" @input="handleSearch" />
      </b-form-group>
      <b-form-group label="Salesperson" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_COMPANIES)">
        <!-- <b-form-input size="sm" v-model="filters.salesPerson" @input="handleSearch" /> -->
        <b-form-select v-model="filters.salesPersonUserId" @change="handleSearch">
          <option :value="null">All</option>
          <option :value="'unassigned'">Unassigned</option>
          <option
            v-for="(selectRep, indexRep) in sortSelect(salesReps)"
            :key="indexRep"
            :value="selectRep.id"
          >{{ selectRep.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Alt Salesperson" class="mr-2">
        <!-- <b-form-input size="sm" v-model="filters.salesPerson" @input="handleSearch" /> -->
        <b-form-select v-model="filters.salesPerson2UserId" @change="handleSearch">
          <option :value="null">All</option>
          <option :value="'unassigned'">Unassigned</option>
          <option
            v-for="(selectRep, indexRep) in sortSelect(salesReps)"
            :key="indexRep"
            :value="selectRep.id"
          >{{ selectRep.name }}</option>
        </b-form-select>
      </b-form-group>
      <!--<b-form-group label="Buyer" class="mr-2">
        <b-form-input size="sm" v-model="filters.buyer"  @input="handleSearch" />
      </b-form-group>-->
      <b-form-group label="Buyer" class="mr-2">
        <b-form-select v-model="filters.buyerPersonUserId" @input="handleSearch" >
          <option :value="null">All</option>
          <option :value="'unassigned'">Unassigned</option>
          <option v-for="(selectRep, indexRep) in sortSelect(buyerReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Class" class="mr-2">
        <b-form-select v-model="filters.accountClassId" @change="handleSearch">
          <option :value="null">All</option>
          <option
            v-for="(type) in sortSelect(accountClasses)"
            :key="type.id"
            :value="type.id"
          >{{type.name}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Active" class="mr-2">
        <b-form-select v-model="filters.active" @change="handleSearch">
          <option :value="null">All</option>
          <option
            v-for="(type) in sortSelect(activeOptions)"
            :key="type.key"
            :value="type.key"
          >{{type.name}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Last modified" class="mr-2">
        <b-form-select v-model="filters.lastModified" @change="onDateRangeChange">
          <option v-for="(type) in dateRangeTypes" :key="type" :value="type">{{type}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="From" v-if="filters.lastModified === dateRangeTypes.CUSTOM" class="mr-2">
        <date-picker v-model="filters.dateFrom" :config="datePickerOptions" size="sm" />
      </b-form-group>
      <b-form-group label="To" v-if="filters.lastModified === dateRangeTypes.CUSTOM" class="mr-2">
        <date-picker v-model="filters.dateTo" :config="datePickerOptions" size="sm" />
      </b-form-group>
    <div class="clear-filter-button-container">
      <!-- <b-button variant="primary" size="sm" class="mr-2" @click="handleSearch">Search</b-button> -->
      <b-button size="sm" @click="handleClearFilter">Clear filters</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import { getDatesFromRangeString, sortAttributes, withAllOption } from '@/shared/helpers';


export default {
  props: {
    name: String,
    toggleAdvancedFilters: Function,
  },
  data: function() {
    return {
      activeOptions: ACTIVE,
      withAllOption,
      dateRangeTypes: REQUEST_DATE,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      // filters: {
      //   accountTypeId: null,
      //   accountClassId: null,
      //   lastModified: null,
      //   dateFrom: null,
      //   dateTo: null,
      //   attributeId: null,
      //   salesPerson: null,
      //   salesPersonUserId: null,
      //   salesPerson2UserId: null,
      //   buyer: null,
      //   name: this.name,
      //   active: null,
      //   countryCode: null,
      //   state: '',
      // },
    };
  },
  computed: {
    ...mapGetters('accountTypes', ['sortedAccountTypes']),
    ...mapGetters('attributes', ['attributes']),
    ...mapGetters('accountClasses', ['accountClasses']),
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('account', ['isAdministrator']),
    ...mapGetters('address', [
      'countryCodes',
    ]),
    ...mapGetters('companies', ['filters']),
    ...mapState('buyerReps', ['buyerReps']),
    ...mapState('lookup', ['accountTypeAttributes']),
    filteredAttributes() {
      let attrib = [];
      let dist = [], flag = [];

      if(this.filters.accountTypeId > 0){
        attrib = this.accountTypeAttributes.filter(e => e.accountTypeId == this.filters.accountTypeId);
      }
      else{
        attrib = this.accountTypeAttributes;
      }

      for (let i = 0; i < attrib.length; i++) {
        if (flag.indexOf(attrib[i].attributeId) > -1) continue;
        dist.push(attrib[i])
        flag.push(attrib[i].attributeId);
      }
        
      return dist;
    }
  },
  methods: {
    ...mapActions('salesReps', ['getSalesReps']),
    ...mapActions('address', ['getCountryCodes']),
    ...mapActions('buyerReps', ['getBuyerReps']),
    // formSubmit(e) {
    //   console.log ("Form Submitted");
    //   e.preventDefault();
    //   this.handleSearch();
    // },
    handleSearch: debounce(function () {
      const filters = this.filters;
      delete filters.lastModified;

      console.log('filters :', filters);

      this.$emit('search', filters);
    }, SEARCH_DEBOUNCE_TIME),
    handleClearFilter() {
      Object.keys(this.filters).forEach(filterName => {
        if (filterName != 'accountTypeId')
          this.filters[filterName] = null;
           this.filters['isShowAvl'] = true;
           this.filters['isShowNonAvl'] = true;
      });

      this.handleSearch();
    },
    onDateRangeChange(value) {
      if (value === REQUEST_DATE.CUSTOM) {
        this.filters.dateFrom = null;
        this.filters.To = null;
      } else {
        const { dateFrom, dateTo } = getDatesFromRangeString(value);

        Object.assign(this.filters, {
          dateFrom,
          dateTo,
        });

        this.handleSearch();
      }
    },
  },
  async mounted() {
    this.getSalesReps();
    // this.getCountryCodes();
    this.getBuyerReps();
  }
};
</script>

<style>
.clear-filter-button-container {
  margin-top: 12px;
  text-align: right;
}
</style>
